import React, { useEffect, useState } from "react";
import { ComponentInfo, ComponentInput, ComponentLine, ModalService } from "../styled";


import { Button, Flex, Input, Radio, Modal, Alert } from 'antd';
import { Box, CircularProgress } from "@mui/material";
import { LiaUserEditSolid } from "react-icons/lia";
import { TruckOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

import { Method_POST, buscarCEP, buscarClienteReceitaFederal, ibge_POST } from "../../../../../../service/api";
import { formatCNPJ, formatCPF, formatValueBrl } from "../../../../../../function/utilis/function";
import { ServiceDownloadCertificadoDigital } from "../../../../../../service/downloadService";
import listEstadosBrasileiros from "../../../../../../function/helpers/listUF.json"

import OptionCredenciaisDeAcesso from "./OptionCredenciaisDeAcesso";
import ModalImportarCertificado from "./ModalImportCertificado";
import OptionEndereco from "./OptionEndereco";
import OptionEmpresa from "./OptionEmpresa";
import OptionDadosDaEmpresa from "./OptionDadosDaEmpresa";

const { Search } = Input;


export function AtualizarCliente({info, fetchData, numeroSolicitacao, setIsModalAtualizarCliente, isModalAtualizarCliente, setisModalImportsAberturaAlteracaoEmpresa, opcaoDadosEmpresa, setModalUploadDoc}) {
    const [selectedOption, setSelectedOption] = useState(opcaoDadosEmpresa || "empresa");
    const [selectedOptionCredenciais, setSelectedOptionCredenciais] = useState('certificado');

    const [listCarteira, setListCarteira] = useState([]);
    const [listEquipe, setListEquipe] = useState([]);
    const [listMunicipio, setListMunicipio] = useState([]);
    const [listEstado, setListEstado] = useState(listEstadosBrasileiros);
    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [loadingSearchCep, setLoadingSearchCep] = useState(false);
    const [loadingDownloading, setLoadingDownloading] = useState(false);
    const [statusInput, setstatusInput] = useState([]);

    const [isModalImportCertificado, setIsModalImportCertificado] = useState(false);
    const [isDataEnquadramento, setIsDataEnquadramento] = useState(false);
    const [isProcuracaoDigital, setIsProcuracaoDigital] = useState(true);
    const [isMostrarCamposCasoSegmentoAtualForDiferenteDePS, setIsMostrarCamposCasoSegmentoAtualForDiferenteDePS] = useState(false)
    const [isCampoIE, setisCampoIE] = useState(true);
    const [isCampoSituacaoIE, setIsCampoSituacaoIE] = useState(true);
    const [isDataOpcaoSN, setIsDataOpcaoSN] = useState(false);
    const [isDataInicioVigencia, setIsDataIniciovigencia] = useState(false);
    const [isDataTermicoVigencia, setIsDataTerminoVigencia] = useState(false);
    const [isCertificadoDigital, setIsCertificadoDigital] = useState(false);
    const [isModalAlert, setIsModalAlert] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertValidacao, setAlertValidacao] = useState(false);
    const [isAviso, setIsAviso] = useState(false);
    const [alertResponseError, setAlertResponseError] = useState("");
    const [dataCliente, setDataCliente] =  useState([]);
    const numSolicitacao = numeroSolicitacao;

    const [dadosCliente, setdadosCliente] = useState({
        clienteId: "",
        carteiraCliente: "",
        equipe: "",
        cnpjCliente: "",
        atividade: "",
        dataCadastro: "",
        dataConstituicao: "",
        dataReenquadramento: "",
        razaoSocial: "",
        tipoPessoa: "",
        nomeFantasia: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        estado: "",
        tipoEmpresa: "",
        enquadramento: "",
        segmentoAtuacao: "",
        regimeTributario: "",
        dataAnaliseSN: "",
        dataOpcaoSN: "",
        nire: "",
        im: "",
        ie: "",
        situacaoIe: "",
        contribuicaoIe: "",
        formaAtuacao: "",
        valorMensal: "",
        valorAssinatura: "",
        valorAdicional: "",
        procuracaoDigital: "",
        faixaFaturamento: "",
        certificadoCedido: "",
        dataInicioProcuracaoDigital: "",
        dataTerminoProcuracaoDigital: "",
        arquivoDigital: "",
        certificadoModalidade: "",
        certificadoTipo: "",
        certificadoSenha: "",
        certificadoDataExpiracao: "",
        acessoContador: "",

        codigoAcessoSN: "",
        cpfAcessoSN: "",
        codigoReciboIRPF1:"",
        codigoReciboIRPF2: "",

        codigoAcessoGov: "",
        senhaAcessoGov: "",
        codigoAcessoNFSe: "",
        senhaAcessoNFSe: "",

        codigoAcessoNFe: "",
        senhaAcessoNFe: "",
        codigoAcessoECAC: "",
        senhaAcessoECAC: "",
        tipoAcessoECAC: "",
        codigoAcessoEW: "",
        senhaAcessoEW: "",

        dataPedidoSN: "",
        contribuicaoIe: "",

        files: "",
    })

    useEffect(()=> {
        fetchConsultar();
        fetchCarteiraListar();
        fetchEquipeListar();
        fetchIbge();
    }, [])

    const validarCamposAntesDeContinuar = () => {
      const camposObrigatorios = ["cnpjCliente", 
        "razaoSocial", 
        "nomeFantasia", 
        "dataConstituicao", 
        "cep", 
        "numero", 
        "complemento", 
        "tipoEmpresa", 
        "regimeTributario", 
        "segmentoAtuacao", 
        "nire", 
        "formaAtuacao"];
      const camposVazios = camposObrigatorios.filter((campo) => !dadosCliente[campo]);
    
      if (camposVazios.length > 0) {
        setstatusInput(camposVazios);
        setLoading(false);
      }
    
      setstatusInput([]);
      return true;
    };

    const mapearDadosCliente = (response) => ({
        clienteId: response.id,
        carteiraCliente: response.carteira?.id,
        equipe: response.equipe?.id,
        cnpjCliente: response.cnpj,
        dataCadastro: response.dataCadastro,
        dataConstituicao: response.dataConstituicao,
        dataReenquadramento: response.dataReenquadramento,
        razaoSocial: response.nome,
        nomeFantasia: response.nomeFantasia,
        tipoPessoa: response.tipoPessoa,
        cep: response.endereco?.cep,
        logradouro: response.endereco?.logradouro,
        numero: response.endereco?.numero,
        complemento: response.endereco?.complemento,
        bairro: response.endereco?.bairro,
        cidade: response.endereco?.cidade,
        estado: response.endereco?.uf,
        tipoEmpresa: response.tipoEmpresa?.id,
        enquadramento: response.enquadramento?.id,
        segmentoAtuacao: response.segmentoEmpresa?.id,
        regimeTributario: response.regimeTributario?.id,
        dataOpcaoSN: response.dataOpcaoSN,
        nire: info.nire,
        im: response.im,
        ie: response.ie,
        situacaoIe: info.situacaoIE,
        formaAtuacao: info.formaAtuacao,
        contribuicaoIe: info.contribuicaoEstadual,
        faixaFaturamento: response.faixaFaturamento,

        valorMensal: response.servico?.valorMensal,
        valorAssinatura: response.servico?.valorAssinatura,
        valorAdicional: response.servico?.valorAdicional,
       procuracaoDigital:
          response.empresa?.credenciaisAcesso?.procuracaoDigital,
        certificadoCedido:
          response.empresa?.credenciaisAcesso?.certificadoCedido,
        dataInicioProcuracaoDigital:
          response.empresa?.credenciaisAcesso?.dataInicioProcuracaoDigital,
        dataTerminoProcuracaoDigital:
          response.empresa?.credenciaisAcesso?.dataTerminoProcuracaoDigital,
        certificadoModalidade:
          response.empresa?.credenciaisAcesso?.certificadoModalidade,
        certificadoTipo:
          response.empresa?.credenciaisAcesso?.certificadoTipo,
        certificadoSenha:
          response.empresa?.credenciaisAcesso?.certificadoSenha,
        certificadoDataExpiracao:
          response.empresa?.credenciaisAcesso?.certificadoDataExpiracao,
        acessoContador: response.empresa?.credenciaisAcesso?.acessoContador,

        codigoAcessoSN: response.empresa?.credenciaisAcesso?.codigoAcessoSN,
        cpfAcessoSN: response.empresa?.credenciaisAcesso?.cpfAcessoSN,
        codigoReciboIRPF1:
          response.empresa?.credenciaisAcesso?.codigoReciboIRPF1,
        codigoReciboIRPF2:
          response.empresa?.credenciaisAcesso?.codigoReciboIRPF2,
        codigoAcessoGov:
          response.empresa?.credenciaisAcesso?.codigoAcessoGov,
        senhaAcessoGov: response.empresa?.credenciaisAcesso?.senhaAcessoGov,
        codigoAcessoNFSe: response.empresa?.credenciaisAcesso?.codigoAcessoNFSe,
        senhaAcessoNFSe: response.empresa?.credenciaisAcesso?.senhaAcessoNFSe,
        
        codigoAcessoNFe:
          response.empresa?.credenciaisAcesso?.codigoAcessoNFe,
        senhaAcessoNFe: response.empresa?.credenciaisAcesso?.senhaAcessoNFe,
        codigoAcessoECAC:
          response.empresa?.credenciaisAcesso?.codigoAcessoECAC,
        senhaAcessoECAC:
          response.empresa?.credenciaisAcesso?.senhaAcessoECAC,
        tipoAcessoECAC:
          response.empresa?.credenciaisAcesso?.tipoAcessoECAC?.id,
        codigoAcessoEW: response.empresa?.credenciaisAcesso?.codigoAcessoEW,
        senhaAcessoEW: response.empresa?.credenciaisAcesso?.senhaAcessoEW,

        dataPedidoSN: response.dataPedidoSN,

        files: response.empresa?.credenciaisAcesso?.files,
    })
    
    const fetchConsultar = async () => {
        setLoading(true)

        if(info.situacaoId === "A-JCM" && info.tipoId === "1"){
          setAlertValidacao(true);
          validarCamposAntesDeContinuar();
        }

      try {
        const url = `/ordem-servico/cliente/consultar`;
        const data = { id: info.clienteId };

        const response = await Method_POST(url, data);
        
        if (response) {
          setDataCliente(response);
          const dadosMapeados = mapearDadosCliente(response);
          setdadosCliente(dadosMapeados);

          if(response.regimeTributario.id === "SN"){
            setIsDataOpcaoSN(true);
          }

          if (response && response.files) {
            setDataCliente(response.files);
          }

          if (response.segmentoEmpresa?.id != "PS") {
            setIsMostrarCamposCasoSegmentoAtualForDiferenteDePS(true);
          }

          if (response.dataReenquadramento === null && response.dataReenquadramento === "") {
            setIsDataEnquadramento(false);
          }else{
            setIsDataEnquadramento(true);
          }

          if (info.contribuicaoEstadual === "C") {
            setisCampoIE(true);
            setIsCampoSituacaoIE(true);
          }
          if (info.contribuicaoEstadual === "N") {
            setIsCampoSituacaoIE(false);
          }
          if (info.contribuicaoEstadual === "I") {
            setIsCampoSituacaoIE(false);
          }
          if (info.situacaoId === "M-TE" && info.tipoId === "3") {
            setIsProcuracaoDigital(false);
          }

          if (response.empresa?.credenciaisAcesso?.procuracaoDigital) {
            setIsDataIniciovigencia(true);
            setIsDataTerminoVigencia(true);
            setIsCertificadoDigital(false);
          }

          if (response.empresa?.credenciaisAcesso?.certificadoCedido) {
            setIsCertificadoDigital(true);
          }

        }
        
      } catch (error) {
        setLoading(false)
        console.log("Erro:", error);
      }finally{
        setLoading(false)
      }
    };

    const fetchCarteiraListar = async () => {
      try {
        const url = `/carteira/cliente/listar`;
        const data = {};

        const response = await Method_POST(url, data);

        if (response) {
            setListCarteira(response)
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error.message);
      }
    };

    const fetchEquipeListar = async () => {
      try {
        const url = `/equipe/listar`;
        const data = {};

        const response = await Method_POST(url, data);

        if (response) {
            setListEquipe(response);
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error.message);
      }
    };

    const fetchIbge = async () => {
      try {
        const url = `/municipio/listar`;
        const data = { uf: {sigla: info.estado} };

        const response = await ibge_POST(url, data);

        if (response) {
            setListMunicipio(response)
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error.message);
      }
    };

    useEffect(() => {
    if (opcaoDadosEmpresa) {
      setSelectedOption(opcaoDadosEmpresa);
    }
  }, [opcaoDadosEmpresa]);

    const handleRadioChange = (e) => {
      setSelectedOption(e.target.value);
    };

    const handleRadioChangecredenciais = (e) => {
      const selectedOption = e.target.value;
    
      setSelectedOptionCredenciais(selectedOption);
    
      if (selectedOption === "Acesso Remoto") {
        setdadosCliente((prevState) => ({
          ...prevState,
          procuracaoDigital: false,
          acessoContador: true,
          certificadoCedido: false,
        }));
    
        setIsDataIniciovigencia(false);
        setIsDataTerminoVigencia(false);
        setIsCertificadoDigital(false);
      } else {
        setdadosCliente((prevState) => ({
          ...prevState,
          procuracaoDigital: selectedOption === "Procuracao Digital",
          acessoContador: selectedOption === "Acesso Contador",
          certificadoCedido: selectedOption === "Certificado Cedido",
        }));
      }
    };
    
    const onChangeEscolherProcuracaoDigital = (e) => {
      const isChecked = e.target.checked;
    
      setdadosCliente((prevState) => ({
        ...prevState,
        procuracaoDigital: isChecked,
      }));
    
      setIsDataIniciovigencia(isChecked);
      setIsDataTerminoVigencia(isChecked);
    };
    
    const onChangeEscolherAcessoRemoto = (e) => {
      const isChecked = e.target.checked;
    
      setdadosCliente((prevState) => ({
        ...prevState,
        acessoContador: isChecked,
      }));
    };
    
    const onChangeEscolherComoCertificadoDigital = (e) => {
      const isChecked = e.target.checked;
    
      setdadosCliente((prevState) => ({
        ...prevState,
        certificadoCedido: isChecked,
      }));
    
      setIsCertificadoDigital(isChecked);
    };

    const abrirModalImportCertificado = () => {
        setIsModalImportCertificado(true);
    }

    const fecharModalImportCertificado = () => {
        setIsModalImportCertificado(false);
    }

    const handleChangeCarteira = (value) => {
      setdadosCliente((prevState) => ({
        ...prevState,
        carteiraCliente: value,
      }));
    };

    const handleChangeEquipe = (value) => {
      setdadosCliente((prevState) => ({
        ...prevState,
        equipe: value,
      }));
    };

    /**
     * Busca o cliente na Receita Federal (SERPRO) pelo CNPJ.
     *
     * IMPORTANTE: o CNPJ precisa ir pra URL só com dígitos. O campo
     * `dadosCliente.cnpjCliente` guarda o valor formatado (com pontos,
     * barra e traço, ex.: "23.791.830/0001-80") — a barra "/" nesse valor,
     * se for pra URL sem codificar, quebra a rota no servidor (o "/" vira
     * separador de caminho em vez de fazer parte do parâmetro), e é
     * exatamente isso que causava o 404 "No matching resource found".
     */
    const buscarCliente = async () => {
      setLoadingSearch(true);

      const cnpjSomenteNumeros = (dadosCliente.cnpjCliente || "").replace(/\D/g, "");

      if (cnpjSomenteNumeros === "") {
        setstatusInput("error");
        setLoadingSearch(false);
        return;
      }
        try {
          const url = `/retrieve?cnpj=${cnpjSomenteNumeros}&provedor=SERPRO&_=${Date.now()}`;

          const response = await buscarClienteReceitaFederal(url);

          if (!response || response.message) {
            setAlert(true);
            setAlertResponseError(response.message || "CNPJ não encontrado.");
            return;
          }

          if (response) {
            setAlert(false);
            setdadosCliente((prevDadosCliente) => ({
              ...prevDadosCliente,
              razaoSocial: response.nomeEmpresarial,
              cnpjCliente: response.ni,
              nomeFantasia: response.nomeFantasia,
              dataConstituicao: response.dataAbertura,
              cep: response.endereco?.cep,
              logradouro: response.endereco?.logradouro,
              numero: response.endereco?.numero,
              complemento: response.endereco?.complemento,
              bairro: response.endereco?.bairro,
              cidade: response.endereco?.municipio?.descricao,
              estado: response.endereco?.uf,
            }));
          }
        } catch (error) {
            console.error("Erro ao buscar cliente:", error.message);
        }finally{
          setLoadingSearch(false);
        }
    };

    const buscaCep = async () => {
      setLoadingSearchCep(true);

      if(dadosCliente.cep === ""){
        setstatusInput("cep");
        setLoadingSearchCep(false);
        return;
      }
      try {
        const url = `/${
          dadosCliente.cep
        }/json/?callback=jQuery351007902269989644672_1727782116159&_=${Date.now()}`;

        const response = await buscarCEP(url);

        if (response) {
          setLoadingSearchCep(false);
          const jsonResponse = JSON.parse(
            response.substring(
              response.indexOf("(") + 1,
              response.lastIndexOf(")")
            )
          );

          setdadosCliente((prevDadosCliente) => ({
            ...prevDadosCliente,
            cep: jsonResponse.cep,
            logradouro: jsonResponse.logradouro,
            numero: "",
            complemento: jsonResponse.complemento,
            bairro: jsonResponse.bairro,
            cidade: jsonResponse.localidade,
            estado: jsonResponse.uf,
          }));
        }
      } catch (error) {
        console.error("Erro ao buscar CEP:", error.message);
      }finally{
        setLoadingSearchCep(false);
      }
    };

    const validarCamposAntesDeSalvar = () => {  
      if (!dadosCliente.cnpjCliente) {
        setstatusInput("cnpjCliente");
        setLoading(false);
        setIsAviso(true);
        return false;
      }
      
      if (!dadosCliente.enquadramento) {
        setstatusInput("enquadramento");
        setLoading(false);
        setIsAviso(true);
        return false;
      }


      return true;
    };

    const onChangeSelectContribuicaoEstadual = (value) => {
      setdadosCliente((prevStateContribuicao) => ({
        ...prevStateContribuicao,
        contribuicaoIe: value,
      }))

      if(value === "C"){
        setIsCampoSituacaoIE(true);
        setisCampoIE(true);
      }

      if(value === "N"){
        setIsCampoSituacaoIE(false);
        setdadosCliente((statusI) => ({
          ...statusI,
          ie: "",
        }))
      }

      if(value === "I"){
        setIsCampoSituacaoIE(false);

        setdadosCliente((statusI) => ({
          ...statusI,
          ie: "ISENTO",
        }))
      }
    }

    const escolherRegimeTributario = (value) => {
      setIsModalAlert(true);

      setdadosCliente((prev) => ({
        ...prev,
        regimeTributario: value,
      }));
    
      setstatusInput(value === "" ? "error" : "");
    
      if (value === "SN" || value === "SIMEI") {
        setIsDataOpcaoSN(true);
      }else{
        setIsDataOpcaoSN(false);
      }
    };

    const salvar = () => {
      if (!validarCamposAntesDeSalvar()) {
        return;
      }
      atualizar();
    }; 
    
    const atualizar = async () => {
      setLoading(true);
      setAlert(false);

      if (!validarCamposAntesDeSalvar()){
        setLoading(false);
        return
      };

      try {
        const url = "/ordem-servico/cliente/atualizar";
        const payload = {
          id: numSolicitacao,
          tipo: {
            id: info.tipoId,
          },
          cliente: {
            id: dadosCliente.clienteId,
            tipoPessoa: dadosCliente.tipoPessoa,
            cnpj: dadosCliente.cnpjCliente,
            contribuicaoIe: dadosCliente.contribuicaoIe,
            ie:  dadosCliente.ie,
            situacaoIe: dadosCliente.situacaoIe,
            im: dadosCliente.im,
            nire: dadosCliente.nire,
            nome: dadosCliente.razaoSocial,
            nomeFantasia: dadosCliente.nomeFantasia,
            dataConstituicao: dadosCliente.dataConstituicao,
            tipoEmpresa: {
              id: dadosCliente.tipoEmpresa,
            },
            enquadramento: {
              id: dadosCliente.enquadramento,
            },
            segmentoEmpresa: {
              id: dadosCliente.segmentoAtuacao,
            },
            regimeTributario: {
              id: dadosCliente.regimeTributario,
            },
            carteira: {
              id: dadosCliente.carteiraCliente,
            },
            equipe: {
              id: dadosCliente.equipe,
            },
            formaAtuacao: dadosCliente.formaAtuacao === "Não Estabelecido" ? "NE" : dadosCliente.formaAtuacao || dadosCliente.formaAtuacao === "Estabelecida" ? "E" : dadosCliente.formaAtuacao,
          
            endereco: {
              logradouro: dadosCliente.logradouro,
              numero: dadosCliente.numero,
              complemento: dadosCliente.complemento,
              bairro: dadosCliente.bairro,
              ibgeMunicipio: {
                id: "",
                nome: "",
                uf: null,
              },
              cidade: dadosCliente.cidade,
              uf: dadosCliente.estado,
              cep: dadosCliente.cep.replace(/\D/g, ""),
            },
            empresa: {
              credenciaisAcesso: {
                acessoContador: dadosCliente.acessoContador,
                procuracaoDigital: dadosCliente.procuracaoDigital,
                certificadoCedido: dadosCliente.certificadoCedido,
                codigoAcessoSN: dadosCliente.codigoAcessoSN,
                cpfAcessoSN: dadosCliente.cpfAcessoSN,
                codigoReciboIRPF1: dadosCliente.codigoReciboIRPF1,
                codigoReciboIRPF2: dadosCliente.codigoReciboIRPF2,
                codigoAcessoGov: dadosCliente.codigoAcessoGov,
                senhaAcessoGov: dadosCliente.senhaAcessoGov,
                codigoAcessoNFSe: dadosCliente.codigoAcessoNFSe,
                senhaAcessoNFSe: dadosCliente.senhaAcessoNFSe,
                codigoAcessoNFe: dadosCliente.codigoAcessoNFe,
                senhaAcessoNFe: dadosCliente.senhaAcessoNFe,
                tipoAcessoECAC: {
                  id: dadosCliente.tipoAcessoECAC,
                },
                codigoAcessoECAC: dadosCliente.codigoAcessoECAC,
                senhaAcessoECAC: dadosCliente.senhaAcessoECAC,
                codigoAcessoEW: dadosCliente.codigoAcessoEW,
                senhaAcessoEW: dadosCliente.senhaAcessoEW,

                dataInicioProcuracaoDigital: dadosCliente.procuracaoDigital === true ? dadosCliente.dataInicioProcuracaoDigital : "",
                dataTerminoProcuracaoDigital: dadosCliente.procuracaoDigital === true ? dadosCliente.dataTerminoProcuracaoDigital : "",

                certificadoModalidade: dadosCliente.certificadoModalidade,
                certificadoTipo: dadosCliente.certificadoTipo,
                certificadoSenha: dadosCliente.certificadoSenha,
                certificadoDataExpiracao: dadosCliente.certificadoDataExpiracao,
              },
            },
            dataPedidoSN: dadosCliente.dataPedidoSN,
            dataOpcaoSN: dadosCliente.dataOpcaoSN,
            servico: {
              valorMensal: dadosCliente.valorMensal,
              valorAssinatura: dadosCliente.valorAssinatura,
              valorAdicional: dadosCliente.valorAdicional,
            },
            dataReenquadramento: "",
          },
        };

        const response = await Method_POST(url, payload);

        if (response.erro?.categoria?.id === "B") {
          setAlert(true);
          setAlertResponseError(response.erro.mensagem);
          return;
        }
        if (response) {
          setAlert(false);
          setAlertResponseError(false);
          await fetchData();
          toast.success("Dados atualizado com sucesso!");
          setIsModalAtualizarCliente(false);
        }else{
          toast.error("Dados não atualizados.");
        }
      } catch (err) {
        console.error("Erro na requisição:", err);
      } finally {
        setLoading(false);
      }
    };

    const onChangeSelectSegmentoEmpresa = (value) => {
      setIsModalAlert(true);
      if(value != "PS"){
        setIsMostrarCamposCasoSegmentoAtualForDiferenteDePS(true);
      }else{
        setIsMostrarCamposCasoSegmentoAtualForDiferenteDePS(false);
      }
      setstatusInput(value === "" ? "error" : "");

      setdadosCliente((prevState) => ({
        ...prevState,
        segmentoAtuacao: value,
      }));
    }

    const calcularFaixaFaturamento = (value, isMCP) => {
      if (value === 81000) return "81000";
    
      if (isMCP) {
        if (value >= 1000001) return "1000001";
        if (value > 800000) return "1000000";
        if (value > 500000) return "800000";
        if (value > 400000) return "500000";
        if (value > 300000) return "400000";
        if (value > 200000) return "300000";
        if (value > 150000) return "200000";
        if (value > 100000) return "150000";
        if (value > 50000) return "100000";
        return "50000";
      } else {
        if (value >= 12000001) return "12000001";
        if (value > 6000000) return "12000000";
        if (value > 3600000) return "6000000";
        if (value > 2400000) return "3600000";
        if (value > 1440000) return "2400000";
        if (value > 1200000) return "1440000";
        if (value > 720000) return "1200000";
        return "720000";
      }
    };

    const calcular = async () =>{ 
      try {
          const url = `/ordem-servico/assinatura/calcular`;

          const faturamentoFaixa = calcularFaixaFaturamento(
            dadosCliente.faixaFaturamento
          );
    
          const payload = {
              tipo: {
                  id: "1"
              },
              dataCriacao: new Date(info.dataCriacao).toISOString(),
              situacao: {
                  id: "S"
              },
              dataSituacao: new Date(),

              empresa: {
                  tipo: {
                      id: dadosCliente.tipoEmpresa
                  },
                  segmento: {
                      id: dadosCliente.segmentoAtuacao,
                  },
                  regimeTributario: {
                      id: dadosCliente.regimeTributario,
                  },
                  faturamento: faturamentoFaixa,
                  simplesNacional: dadosCliente.regimeTributario === "SN" || dadosCliente.regimeTributario === "SIMEI" ? true : false,
              }
          };
    
          const response = await Method_POST(url, payload);
    
          if(response){
            setIsModalAlert(false)
          }else{
            toast.error("Calculo não foi realizado");
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
    }

    const escolherSituacaoIE = (value) => {
      setdadosCliente((prevState) => {
        const newState = {
          ...prevState,
          situacaoIe: value,
        };
        return newState;
      });
    };

    const getSituacaoPlaceholder = (situacaoIe) => {
      switch (situacaoIe) {
        case "A":
          return "Ativa";
        case "I":
          return "Inativa";
        case "S":
          return "Suspensa";
        case "IN":
          return "Inapta";
        default:
          return "Selecione";
      }
    };

    const downloadCertificadoDigital = async (id) => {
      const filePath = dadosCliente.files[0];
    
      const fileNameP12 = filePath.endsWith('.p12') ? filePath : `${filePath}.p12`;
      setLoadingDownloading(true);
      try {
        await ServiceDownloadCertificadoDigital(id, fileNameP12);
      } catch (error) {
        toast.error("Erro ao baixar o documento.");
        console.error("Erro no download do certificado digital:", error);
      }finally{
        setLoadingDownloading(false);
      }
    };
    
  return (
    <>
      <Modal 
        title={info.clienteId === "" || info.clienteId === null ? "Cadastrar Cliente" : "Atualizar Cliente"} 
        open={isModalAtualizarCliente} 
        onCancel={() => setIsModalAtualizarCliente(false)}
        onOk={salvar}
        okText="Salvar"
        width="85%">

        <div className="overflow-hidden">
          <div style={{padding: 20}}>
            <div className="instructions">
              <strong>Instruções</strong>
              <p>Informe os dados complementares da empresa do cliente.</p>
            </div>

            {isAviso && (
              <Alert
                message="Atenção"
                description={`O campo [${statusInput}] deve ser preenchido antes de salvar.`}
                type="error"
                showIcon
                closable
              />
            )}

            {alert && (
              <Alert
                message="Atenção"
                description={alertResponseError}
                type="warning"
                showIcon
                closable
              />
            )}

            {alertValidacao && (
              <Alert
                message="Atenção"
                description="Observe, valide e complemente as informações do cliente destacadas antes de continuar. (Verifica as outras abas)"
                type="warning"
                showIcon
                closable
              />
            )}
          </div>

          <div className="padding10 margin-auto" style={{ textAlign: "center" }}>
            <Flex vertical gap="middle">
              <Radio.Group value={selectedOption} onChange={handleRadioChange}>
                <Radio.Button value="empresa">Empresa</Radio.Button>
                <Radio.Button value="endereco">Endereço</Radio.Button>
                <Radio.Button value="dadosEmpresa">Dados da Empresa</Radio.Button>
                <Radio.Button value="MensalidadeServico">
                  Mensalidade de Serviço
                </Radio.Button>
                <Radio.Button value="CredenciaisAcesso">Credenciais</Radio.Button>
              </Radio.Group>
            </Flex>
          </div>

          <ComponentInfo>
            {loading ? (
              <div className="margin-0-auto" style={{textAlign: "center", justifyContent: "center", alignItems: "center", display: "flex"}}>
                <Box sx={{ display: "flex" }}>
                  <CircularProgress />
                </Box>
              </div>
            ) : (
              <>
                <div>
                  {selectedOption === "empresa" && (
                    <>
                      <OptionEmpresa
                        dadosCliente={dadosCliente}
                        listCarteira={listCarteira}
                        listEquipe={listEquipe}
                        handleChangeCarteira={handleChangeCarteira}
                        handleChangeEquipe={handleChangeEquipe}
                        buscarCliente={buscarCliente}
                        loadingSearch={loadingSearch}
                        statusInput={statusInput}
                        setstatusInput={setstatusInput}
                        setdadosCliente={setdadosCliente}
                        isDataEnquadramento={isDataEnquadramento}
                        formatCNPJ={formatCNPJ}
                      />
                    </>
                  )}

                  {selectedOption === "endereco" && (
                    <>
                      <OptionEndereco
                        dadosCliente={dadosCliente}
                        setdadosCliente={setdadosCliente}
                        listMunicipio={listMunicipio}
                        listEstado={listEstado}
                        statusInput={statusInput}
                        setstatusInput={setstatusInput}
                        buscaCep={buscaCep}
                        loadingSearchCep={loadingSearchCep}
                      />
                    </>
                  )}

                  {selectedOption === "dadosEmpresa" && (
                    <>
                      <OptionDadosDaEmpresa 
                        dadosCliente={dadosCliente}
                        statusInput={statusInput}
                        setstatusInput={setstatusInput}
                        setdadosCliente={setdadosCliente}
                        onChangeSelectSegmentoEmpresa={onChangeSelectSegmentoEmpresa}
                        escolherRegimeTributario={escolherRegimeTributario}
                        isDataOpcaoSN={isDataOpcaoSN}
                        TruckOutlined={TruckOutlined}
                        isMostrarCamposCasoSegmentoAtualForDiferenteDePS={isMostrarCamposCasoSegmentoAtualForDiferenteDePS}
                        onChangeSelectContribuicaoEstadual={onChangeSelectContribuicaoEstadual}
                        isCampoIE={isCampoIE}
                        isCampoSituacaoIE={isCampoSituacaoIE}
                        getSituacaoPlaceholder={getSituacaoPlaceholder}
                        escolherSituacaoIE={escolherSituacaoIE}
                        setisModalImportsAberturaAlteracaoEmpresa={setisModalImportsAberturaAlteracaoEmpresa}
                        setModalUploadDoc={setModalUploadDoc}
                      />
                    </>
                  )}

                  {selectedOption === "MensalidadeServico" && (
                    <ComponentLine>
                      <ComponentInput>
                        <p>Valor Mensal</p>
                        <Input
                          placeholder="0,00"
                          value={formatValueBrl(info.valorMensal)}
                          onChange={(e) =>
                            setdadosCliente((prevState) => ({
                              ...prevState,
                              valorMensal: e.target.value,
                            }))
                          }
                          style={{ width: 240 }}
                          disabled
                        />
                      </ComponentInput>

                      <ComponentInput>
                        <p>Valor Assinatura</p>
                        <Input
                          placeholder="0,00"
                          value={formatValueBrl(info.valorAssinatura)}
                          onChange={(e) =>
                            setdadosCliente((prevState) => ({
                              ...prevState,
                              valorAssinatura: e.target.value,
                            }))
                          }
                          style={{ width: 240 }}
                          disabled
                        />
                      </ComponentInput>

                      <ComponentInput>
                        <p>Valor Adicional</p>
                        <Input
                          placeholder="0,00"
                          value={formatValueBrl(info.valorAdicional)}
                          onChange={(e) =>
                            setdadosCliente((prevState) => ({
                              ...prevState,
                              valorAdicional: e.target.value,
                            }))
                          }
                          style={{ width: 240 }}
                          disabled
                        />
                      </ComponentInput>
                    </ComponentLine>
                  )}

                  {selectedOption === "CredenciaisAcesso" && (
                    <>
                      <OptionCredenciaisDeAcesso 
                        selectedOptionCredenciais={selectedOptionCredenciais}
                        handleRadioChangecredenciais={handleRadioChangecredenciais}
                        dadosCliente={dadosCliente}
                        dataCliente={dataCliente}
                        info={info}
                        onChangeEscolherProcuracaoDigital={onChangeEscolherProcuracaoDigital}
                        isProcuracaoDigital={isProcuracaoDigital}
                        isDataInicioVigencia={isDataInicioVigencia}
                        statusInput={statusInput}
                        setstatusInput={setstatusInput}
                        setdadosCliente={setdadosCliente}
                        isDataTermicoVigencia={isDataTermicoVigencia}
                        isCertificadoDigital={isCertificadoDigital}
                        loadingDownloading={loadingDownloading}
                        downloadCertificadoDigital={downloadCertificadoDigital}
                        abrirModalImportCertificado={abrirModalImportCertificado}
                        loading={loading}
                        onChangeEscolherComoCertificadoDigital={onChangeEscolherComoCertificadoDigital}
                        onChangeEscolherAcessoRemoto={onChangeEscolherAcessoRemoto}
                        formatCPF={formatCPF}
                      />
                    </>
                  )}
                </div>
              </>
            )}
          </ComponentInfo>

          {isModalImportCertificado && (
            <>
              <ModalImportarCertificado
                numSolicitacao={numSolicitacao}
                fecharModalImportCertificado={fecharModalImportCertificado}
                fetchConsultar={fetchConsultar}
                dadosCliente={dadosCliente}
                setdadosCliente={setdadosCliente}
                fetchData={fetchData}
                info={info}
              />
            </>
          )}

          {isModalAlert && (
            <Modal
              title="Confirmação"
              open={isModalAlert}
              onOk={calcular}
              onCancel={() =>setIsModalAlert(false)}
              okText="Sim"
              cancelText="Não"
            >
              <p>
                Alteração do segmento de atuação ou do regime tributário da
                empresa implicará na atualização do valor da assinatura da
                mensalidade.
              </p>
              <p>
                <strong>Deseja atualizar o valor da mensalidade?</strong>
              </p>
              <Alert
                message="Atenção"
                description="Será necessário
                salvar os dados do cliente para gravar o novo valor da mensalidade
                dos serviços."
                type="warning"
                showIcon
              />
            </Modal>
          )}
        </div>
      </Modal>
    </>
  )
}

export default AtualizarCliente;
